import * as LaunchDarkly from 'launchdarkly-js-client-sdk';
let launchDarklyClient;
let launchDarklyContext;
function getClientSideId() {
    if (!import.meta.env.VITE_LAUNCHDARKLY_CLIENT_SIDE_ID) {
        throw new Error(`Missing VITE_LAUNCHDARKLY_CLIENT_SIDE_ID variable.`);
    }
    return import.meta.env.VITE_LAUNCHDARKLY_CLIENT_SIDE_ID;
}
export async function initialize(context, clientSideId) {
    if (launchDarklyClient) {
        return launchDarklyClient;
    }
    let deviceKey = localStorage.getItem('deviceKey');
    if (!deviceKey) {
        deviceKey = String(Math.floor(Math.random() * 100) + 1);
        localStorage.setItem('deviceKey', deviceKey);
    }
    launchDarklyContext = {
        ...context,
        kind: 'multi',
        device: {
            key: deviceKey,
        },
    };
    launchDarklyClient = LaunchDarkly.initialize(clientSideId || getClientSideId(), launchDarklyContext);
    await launchDarklyClient.waitUntilReady();
    return launchDarklyClient;
}
async function getClient(context, clientSideId) {
    if (launchDarklyClient) {
        return launchDarklyClient;
    }
    launchDarklyClient = await initialize(context, clientSideId);
    return launchDarklyClient;
}
export async function getFlagValue(key, fnChangeListener) {
    if (!launchDarklyContext) {
        return;
    }
    const client = await getClient(launchDarklyContext);
    let flagValue;
    flagValue = await client.variation(key, false);
    if (fnChangeListener) {
        client.on('change:' + key, fnChangeListener);
    }
    return flagValue;
}
export async function getAllFlags(context, clientSideId) {
    const client = await getClient(context, clientSideId);
    return client.allFlags();
}
export async function identify(context, hash, onDone) {
    launchDarklyContext = {
        ...launchDarklyContext,
        ...context,
    };
    return await launchDarklyClient.identify(launchDarklyContext, hash, onDone);
}
